import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { IoClose } from "react-icons/io5";

type NewAchievementNotificationProps = {
  visible: boolean;
};

export default function NewAchievementNotification({ visible }: NewAchievementNotificationProps) {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [isDismissed, setIsDismissed] = useState(false);

  useEffect(() => {
    if (!visible) {
      setIsDismissed(false);
    }
  }, [visible]);

  if (!visible || isDismissed) return null;

  return (
    <div
      dir={i18n.language === "ar" ? "rtl" : "ltr"}
      className="fixed z-60 bottom-4 md:bottom-5 end-4 md:end-5 w-[calc(100%-2rem)] max-w-[360px]"
    >
      <div className="relative overflow-hidden rounded-xl border-[1.5px] border-black-300 bg-primary-ivory shadow-[0px_6px_0px_#110706] p-3.5 md:p-4">
        <button
          type="button"
          onClick={() => setIsDismissed(true)}
          className="absolute top-1.5 end-1.5 h-7 w-7 rounded-full border-[1.5px] border-black-300 bg-white-500 text-black-300 flex items-center justify-center transition-transform hover:scale-105"
          aria-label={t("achievementNotification.dismiss")}
        >
          <IoClose className="h-4.5 w-4.5" />
        </button>
        <div className="pe-7">
          <p className="text-primary-orange font-bold text-base md:text-lg leading-tight">
            {t("achievementNotification.title")}
          </p>
          <p className="text-black-300 mt-1.5 text-xs md:text-sm leading-snug">
            {t("achievementNotification.description")}
          </p>
          <div className="mt-3 flex items-center gap-1.5">
            <button
              type="button"
              onClick={() => {
                setIsDismissed(true);
                navigate("/my-achievements");
              }}
              className="inline-flex items-center justify-center rounded-lg border-[1.5px] border-black-300 bg-primary-yellow px-3 py-1.5 text-xs md:text-sm text-black-300 font-bold shadow-[0px_2px_0px_#110706] transition-transform hover:-translate-y-px"
            >
              {t("achievementNotification.viewAction")}
            </button>
            <button
              type="button"
              onClick={() => setIsDismissed(true)}
              className="inline-flex items-center justify-center rounded-lg border-[1.5px] border-black-300 bg-white-500 px-3 py-1.5 text-xs md:text-sm text-black-300 font-semibold"
            >
              {t("achievementNotification.laterAction")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
